import { Modal } from '../Atoms/Modal'
import {
  ExclamationTriangleIcon,
  ArrowPathIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import { PrimaryButton } from '../Atoms/Buttons'
import { FC } from 'react'

interface UpdateModalProps {
  open: boolean
  onClose: () => void
  onReload: () => void
}

export const UpdateModal: FC<UpdateModalProps> = ({
  open,
  onClose,
  onReload,
}) => {
  return (
    <Modal
      open={open}
      setOpen={onClose}
      className="sm:max-w-md w-full max-w-[95vw] min-h-[18rem]"
    >
      <div className="relative flex flex-col items-center p-6 w-full">
        {/* Botón de cierre (X) */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-1 rounded-full hover:bg-gray-50 active:bg-gray-100 transition-all"
          aria-label="Cerrar modal"
        >
          <XMarkIcon className="w-5 h-5 text-gray-500 hover:text-gray-600 transition-colors" />
        </button>

        {/* Contenido */}
        <div className="flex flex-col items-center justify-center w-full space-y-4">
          <div className="relative">
            <ExclamationTriangleIcon className="text-yellow-500 w-16 h-16 animate-pulse" />
          </div>

          <h3 className="text-xl font-bold text-center text-gray-800">
            Nueva versión disponible
          </h3>

          <p className="text-center text-gray-600">
            Hay una actualización de la aplicación.
            <br /> Por favor, recarga la página para obtener la última versión.
          </p>

          <div className="flex flex-wrap justify-center gap-4 w-full pt-4">
            <PrimaryButton
              onClick={onReload}
              className="px-4 py-2 flex items-center gap-2"
            >
              <ArrowPathIcon className="w-5 h-5" />
              Recargar ahora
            </PrimaryButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}
